import Vue from 'vue'

Vue.mixin({
  updated() {
    this.resize()
  },
  methods: {
    resize() {
      const bottom = document.getElementById('m-app-bottom')
      this.App.state.bottomHeight = (bottom?.offsetHeight || 0) + 'px'

      const toolbar = document.getElementById('a-toolbar')
      const header = document.getElementById('o-template-header')
      this.App.state.headerHeight =
        (toolbar?.offsetHeight || 0) + (header?.offsetHeight || 0) + 'px'
    }
  }
})
